module.exports = __webpack_public_path__ + "fonts/fdc99fe.ttf";